import React, { useEffect, useState } from 'react'
import styles from './DigitalInstrumentalCluster.module.css'
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";

function TopBottomPerformingVehicles(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [vehicleDetails, setVehicleDetails] = useState([]);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "real_time_fault_code/" + props.tableData.apiEnd,
        body: { filterdata: props.gloablfilter },
      },
      appyData
    );
  }, [props.gloablfilter]);

  const appyData = (data) => {
    setVehicleDetails(data);
  };

  return (
    <div className={`${styles.fullTable} p-0`}>
      <div className={`${styles.tableTitles}`}>
        <span className="text-start">{props.tableData.Tabtitle}</span>
      </div>
      <div className={`m-0 ${styles.topBottomPerformingTables}`}>
        <table className="table table-striped">
          <thead style={{ backgroundColor: 'rgb(53, 134, 150)', color: 'rgb(255, 255, 255)', position: 'sticky', top: '0px' }}>
            <tr>
              <th scope="col">{props.tableData.tabCol1}</th>
              <th scope="col">{props.tableData.tabCol2}</th>
            </tr>
          </thead>
          <tbody>
            {vehicleDetails.map((ele, i) => (
              <tr>
                <td scope="row" className="hand_geture" onClick={() => {
                  if (props.tableData.apiEnd === 'faulty_ECU_vehicles') {
                    props.singleVinSelected(ele.key);
                  } else {
                    props.singleVinSelected(ele._source.vehicleId);
                  }
                }}>
                  {(props.tableData.apiEnd === 'faulty_ECU_vehicles') ? ele.key : ele._source.vehicleId}
                </td>
                <td>
                  {props.tableData.apiEnd === 'battery_temp_vehicles' && ele._source.BMS_Max_Cell_Temperature?.toFixed(1)}
                  {props.tableData.apiEnd === 'motor_temp_vehicles' && ele._source.MCU_Motor_Temperature?.toFixed(1)}
                  {props.tableData.apiEnd === 'lowest_SOC_vehicles' && ele._source.State_of_Charge_SOC?.toFixed(1)}
                  {props.tableData.apiEnd === 'faulty_ECU_vehicles' && ele.fault_condition_matches.value?.toFixed(1)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TopBottomPerformingVehicles